// extracted by mini-css-extract-plugin
export default {"modal":"ModalImage_modal__8G+w-","opacity":"ModalImage_opacity__-MJms","cell":"ModalImage_cell__9RKJ2","image":"ModalImage_image__kzW9G"};